import { DetailsListType } from '@flexo/hooks';
import { DetailsList, PaymentsList } from '@flexo/molecules';

type CompositeItem = {
  id?: string;
  type: string;
  data?: any;
  className?: string;
  [k: string]: any;
};

type CompositeProps = {
  // props from factory: include parent config, className, data, widgetsData, etc.
  items?: CompositeItem[];
  className?: string;
  data?: any;
};

/**
 * Composite container that renders inner items like the factory would.
 * It expects items: [{ type: 'SiteDetailsParameters' }, { type: 'siteMembersList' }]
 */
export default function ParametersDetails(props: CompositeProps) {
  const { items = [], className, data = null } = props;


  const renderItem = (item: CompositeItem, index: number) => {
    const key = item.id || item.type;
    // Map composite item id/type to DetailsListType expected values
    let detailsType: DetailsListType | null = null;

    switch (key) {
      case 'SiteDetailsParameters':
      case 'siteDetails':
        detailsType = 'siteDetails';
        break;
      case 'siteMembersList':
      case 'siteMembers':
        detailsType = 'siteMembers';
        break;
      case 'MemberDetailsParameters':
      case 'memberDetails':
        detailsType = 'memberDetails';
        break;
      case 'CommunityDetailsParameters':
      case 'communityDetails':
        detailsType = 'communityDetails';
        break;
      case 'memberSitesList':
      case 'memberSites':
        detailsType = 'memberSites';
        break;
      case 'communityPaymentsList':
        detailsType = 'communityPaymentsList';
        break;
      default:
        detailsType = null;
    }

    if (!detailsType) return null;

    if (detailsType === 'communityPaymentsList') {
      return (
        <div key={item.id || `${item.type}-${index}`} >
          <PaymentsList type={detailsType} data={ item.data || data || null} />
        </div>
      );
    }

    return (
      <div key={item.id || `${item.type}-${index}`} >
        <DetailsList type={detailsType} data={ item.data || data || null} />
      </div>
    );
  };

  return (
    <div >
      {Array.isArray(items) && items.map(renderItem)}
    </div>
  );
}